import { FC, useCallback, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import classNames from 'classnames';

import ImageSlickCarousel from '@components/ImageMultiCarousel/ImageMultiCarousel';
import Modal from '@components/Modal/Modal';
import { ISupplementImage } from '@interfaces/adminSupplements';

import './styles.scss';

export interface IProps {
  images: ISupplementImage[];
  initialSlide: number;
  handleClose: () => void;
}

const FullSizeModalSlider: FC<IProps> = ({ images, initialSlide, handleClose }) => {
  const containerRef = useRef<HTMLElement>(null);

  const [containerHeight, setContainerHeight] = useState<number | null>();

  const onSliderInit = useCallback(() => {
    setContainerHeight(containerRef.current?.clientHeight);
  }, [containerRef.current]);

  return (
    <Modal onClose={handleClose} open className="full-size-slider-modal">
      <Box
        className={classNames('full-size-slider-modal__container', {
          'full-size-slider-modal__container--no-arrows': images.length < 2,
        })}
        ref={containerRef}
      >
        <ImageSlickCarousel
          onInit={onSliderInit}
          slidesToShow={1}
          initialSlide={initialSlide}
          showArrows={images.length > 1}
        >
          {images.map(image => (
            <Box key={image.origFileName} className="full-size-slider-modal__slide-holder">
              <Box
                className="full-size-slider-modal__slide-inner"
                sx={{
                  height: `${containerHeight}px`,
                }}
              >
                <Box className="full-size-slider-modal__title">
                  <IconButton onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                  <Box className="full-size-slider-modal__title-text">{image.origFileName}</Box>
                </Box>
                <Box className="full-size-slider-modal__slide">
                  <Box
                    className="full-size-slider-modal__image"
                    component="img"
                    src={image.url}
                    alt={image.origFileName}
                  />
                </Box>
              </Box>
            </Box>
          ))}
        </ImageSlickCarousel>
      </Box>
    </Modal>
  );
};

export default FullSizeModalSlider;
